jQuery(function($)
{
    var
        { show } = orion,
        { hide } = orion,
        classLoading = 'loading',
        classesPosition = 'left top right bottom',
        $body = $('body'),
        mouseLeaveDelay = false,

        selectorTrigger = '.content-bubble-trigger',
        selectorBubbleContent = '.content',
        selectorBubbleClose = '.close',
        $contentBubble = $('.content-bubble').css({
            'position': 'absolute',
            'left': '0',
            'top': '0'
        });
    /*
		 *state = {
		 * 'isOpen': false
		 *};
		 */

    function init()
    {
        if ($(selectorTrigger).length > 0)
        {
            $(selectorTrigger).each(function()
            {
                var $trigger = $(this);
                var type = getType($trigger);

                if (type === 'hover')
                {
                    initHoverEvents($trigger);
                }
                else if (type === 'click')
                {
                    initClickEvents($trigger);
                }
                else
                {
                    initClickEvents($trigger);
                }
            });
        }
    }

    function initHoverEvents($trigger)
    {
        if (orion.getShopViewCode() == 'desktop')
        {
            $trigger
                .on('click', handleMouseEnterClickTrigger)
                .on('mouseenter', handleMouseEnterTrigger)
                .on('mouseleave', handleMouseLeaveTrigger);

            $contentBubble
                .on('mouseenter', null, $trigger, handleMouseEnterBubble)
                .on('mouseleave', null, $trigger, handleMouseLeaveBubble);
        }
        else
        {
            $trigger
                .on('touchstart', handleClickTrigger);
        }
    }

    function initClickEvents($trigger)
    {
        $trigger.on('click', handleClickTrigger);
    }

    function getType($trigger)
    {
        var type = $trigger.data('bubble-type');

        return type;
    }

    function getSource($trigger)
    {
        return $trigger.data('bubble-source');
    }

    function getContentPromise($trigger)
    {
        var
            promise,
            source;

        if ($trigger.data('contentbubble-promise'))
        {
            return $trigger.data('contentbubble-promise');
        }

        source = getSource($trigger);
        if (source.match(/^#/))
        {
            var deferred = $.Deferred();

            deferred.done(function(content)
            {
                return content;
            });

            deferred.resolve($(source).html());
            return deferred.promise();
        }
        else if (source == 'kendo')
        {
            return;
        }
        else
        {
            promise = $.ajax({
                'url': getSource($trigger)
            });
        }

        $trigger.data('contentbubble-promise', promise);

        return promise;
    }

    function positionToDefault($bubble, $trigger)
    {
        var
            offsetTrigger = $trigger.offset();

        offsetTrigger.left = '';
        offsetTrigger.top = '';

        $bubble.css(offsetTrigger);
    }

    function positionBubbleLeft($bubble, $trigger)
    {
        var
            offsetTrigger = $trigger.offset();

        offsetTrigger.left = offsetTrigger.left - $bubble.outerWidth();
        offsetTrigger.top = offsetTrigger.top + ($trigger.height() - $bubble.outerHeight()) / 2;

        $bubble.css(offsetTrigger);
    }

    function positionBubbleTop($bubble, $trigger)
    {
        var
            offsetTrigger = $trigger.offset();

        offsetTrigger.left = offsetTrigger.left + ($trigger.width() - $bubble.outerWidth()) / 2;
        offsetTrigger.top = offsetTrigger.top - $bubble.outerHeight();

        $bubble.css(offsetTrigger);
    }

    function positionBubbleRight($bubble, $trigger)
    {
        var
            offsetTrigger = $trigger.offset();

        offsetTrigger.left = offsetTrigger.left + $trigger.width();
        offsetTrigger.top = offsetTrigger.top + ($trigger.height() - $bubble.outerHeight()) / 2;

        $bubble.css(offsetTrigger);
    }

    function positionBubbleBottom($bubble, $trigger)
    {
        var
            offsetTrigger = $trigger.offset();

        offsetTrigger.left = offsetTrigger.left + ($trigger.width() - $bubble.outerWidth()) / 2;
        offsetTrigger.top = offsetTrigger.top + $trigger.height();

        $bubble.css(offsetTrigger);
    }

    function positionBubble($bubble, position, $trigger)
    {
        console.log('positionBubble()');
        $bubble
            .removeClass(classesPosition)
            .addClass(position);

        switch (position)
        {
        case 'left':
            positionBubbleLeft($bubble, $trigger);
            break;
        case 'top':
            positionBubbleTop($bubble, $trigger);
            break;
        case 'right':
            positionBubbleRight($bubble, $trigger);
            break;
        case 'bottom':
            positionBubbleBottom($bubble, $trigger);
            break;
        case 'none':
            positionToDefault($bubble, $trigger);
            break;
        default:
            break;
        }
    }

    function closeBubble($bubble, $trigger)
    {
        if ($bubble.hasClass('hidden'))
        {
            return;
        }

        if ($trigger)
        {
            var bubbleClass = $trigger.data('bubble-class');

            $bubble.removeClass(bubbleClass);
        }

        hide($bubble);
        $bubble.find(selectorBubbleContent).html('');
    }

    function openBubble($bubble, $trigger)
    {
        if (!$bubble.hasClass('hidden'))
        {
            return;
        }

        var
            bubblePosition = $trigger.data('bubble-position'),
            bubbleClass = $trigger.data('bubble-class');

        if (!getSource($trigger))
        {
            return;
        }

        show($bubble.addClass(classLoading));

        if (bubbleClass !== undefined)
        {
            $bubble.addClass(bubbleClass);
        }

        setTimeout(positionBubble($bubble, bubblePosition, $trigger), 15);

        $bubble.on('kendoContentBubbleLoaded', function()
        {
            setTimeout(positionBubble($bubble, bubblePosition, $trigger), 15);
        });

        $trigger.trigger('contentBubbleOpened');

        var source = getSource($trigger);

        if (source != 'kendo')
        {
            getContentPromise($trigger).done(function(content)
            {
                content = content.replace(/<script[^<]*<\/script>/g, '');

                $bubble
                    .removeClass(classLoading)
                    .find(selectorBubbleContent)
                    .html(content)
                    .end();

                setTimeout(positionBubble($bubble, bubblePosition, $trigger), 15);
                $trigger.trigger('contentBubbleLoaded');
            });
        }
    }

    function handleMouseEnterTrigger()
    {
        var $trigger = $(this);

        if ($contentBubble.data('content-bubble-trigger-data') != this
			|| $contentBubble.data('content-bubble-trigger-data') == undefined)
        {
            closeBubble($contentBubble, $trigger);
        }

        if (mouseLeaveDelay)
        {
            clearTimeout(mouseLeaveDelay);
            mouseLeaveDelay = false;
        }

        openBubble($contentBubble, $trigger);

        $contentBubble.data('content-bubble-trigger-data', this);
    }

    function handleMouseEnterClickTrigger(e)
    {
        e.preventDefault();
    }

    function handleMouseLeaveTrigger()
    {
        var $trigger = $(this);

        mouseLeaveDelay = setTimeout(function()
        {
            closeBubble($contentBubble, $trigger);
        }, 300);
    }

    function handleMouseEnterBubble()
    {
        if (mouseLeaveDelay)
        {
            clearTimeout(mouseLeaveDelay);
            mouseLeaveDelay = false;
        }
    }

    function handleMouseLeaveBubble(e)
    {
        var $trigger = e.data;

        $trigger.each(function()
        {
            handleMouseLeaveTrigger.apply(this);
        });
    }

    /*
	 *function handleMouseLeaveKendoRow(e) {
	 * var $trigger = e.data;
	 *
	 * console.log('leave-row');
	 *
	 * if (mouseLeaveDelay) {
	 * console.log('cleartimeout');
	 * clearTimeout(mouseLeaveDelay);
	 * mouseLeaveDelay = false;
	 * }
	 *
	 * closeBubble($contentBubble, $trigger);
	 *}
	 */

    function handleClickClose(e)
    {
        e.preventDefault();

        var trigger = $contentBubble.data('content-bubble-trigger-data');
        var $trigger = $(trigger);

        closeBubble($contentBubble, $trigger);
    }

    function handleClickBubble(e)
    {
        e.stopPropagation();
    }

    function handleClickBody(e)
    {
        if (!$contentBubble.hasClass('hidden') && !$(e.target).is('.content-bubble-trigger'))
        {
            closeBubble($contentBubble);
        }
    }

    function handleOverlayOpened()
    {
        if (!$contentBubble.hasClass('hidden'))
        {
            closeBubble($contentBubble);
        }
    }

    function handleFolddownOpened()
    {
        if (!$contentBubble.hasClass('hidden'))
        {
            closeBubble($contentBubble);
        }
    }

    function handleDropdownOpened()
    {
        if (!$contentBubble.hasClass('hidden'))
        {
            closeBubble($contentBubble);
        }
    }

    function handleClickTrigger(e)
    {
        e.preventDefault();

        var $trigger = $(this);

        if ($contentBubble.hasClass('hidden'))
        {
            openBubble($contentBubble, $trigger);
        }
        else
        {
            closeBubble($contentBubble, $trigger);
        }

        $contentBubble.data('content-bubble-trigger-data', this);
    }

    init();

    $body
        .on('click', handleClickBody)
        .on(orion.constants.EventOverlayOpened, handleOverlayOpened)
        .on(orion.constants.EventFolddownOpened, handleFolddownOpened)
        .on(orion.constants.EventDropdownOpened, handleDropdownOpened);

    $contentBubble
        .on('click', selectorBubbleClose, handleClickClose)
        .on('click', handleClickBubble);

    $('.kendoShoppingList').on('detailDataBound', init);
    $('.kendoOrderList').on('detailDataBound', init);
});
